var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNexo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#1A4199"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M6.00525 4.00773L12.042 7.49016V11.0446L2.8125 5.71435L5.77406 4.00773C5.80998 3.98699 5.85072 3.97607 5.89219 3.97607C5.93366 3.97607 5.9744 3.98699 6.01031 4.00773",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M12.042 3.9375L8.96681 5.715L12.042 7.49025V3.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.042 3.9375L15.003 5.64525C15.0402 5.66541 15.0714 5.69521 15.0931 5.73153C15.1149 5.76785 15.1265 5.80935 15.1268 5.85169V12.8205L12.042 11.0447V3.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M15.1206 12.8204L12.1596 14.5265C12.1233 14.5462 12.0827 14.5565 12.0414 14.5565C12.0002 14.5565 11.9596 14.5462 11.9233 14.5265L5.88657 11.0446V7.48511L15.1206 12.8204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M2.8125 5.71509V12.6828C2.81263 12.7252 2.8242 12.7668 2.84597 12.8033C2.86775 12.8397 2.89893 12.8696 2.93625 12.8898L5.89781 14.5975V7.48528L2.8125 5.71509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M5.89275 14.5969L8.96681 12.8205L5.89275 11.0447V14.5969Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexo);
export default __webpack_public_path__ + "static/media/nexo.efd667e5ba553952852c191f91ebcb23.svg";
export { ForwardRef as ReactComponent };